import { memo } from 'react';
import { Box, Skeleton } from '@betty/moonlight';
import { PaymentInteracSkeletonProps } from './PaymentInteracSkeleton.types';

function PaymentInteracSkeleton({
  showAmountField,
  showFooter,
}: PaymentInteracSkeletonProps) {
  return (
    <Box paddingTop="space-400">
      <Skeleton
        height={56}
        borderRadius="radius-200"
        backgroundColor="screenBackground"
      />
      <Skeleton
        height={56}
        borderRadius="radius-200"
        backgroundColor="screenBackground"
        marginTop="space-400"
      />
      <Skeleton
        height={24}
        marginTop="space-600"
        backgroundColor="screenBackground"
      />
      {showAmountField && (
        <Skeleton
          height={56}
          borderRadius="radius-200"
          backgroundColor="screenBackground"
          marginTop="space-400"
        />
      )}
      <Skeleton
        height={40}
        marginTop="space-1000"
        backgroundColor="screenBackground"
      />
      {showFooter && (
        <Skeleton
          height={15.6}
          marginTop="space-300"
          backgroundColor="screenBackground"
        />
      )}
    </Box>
  );
}

export default memo(PaymentInteracSkeleton);
